module.exports = __webpack_public_path__ + "img/15-1_05.6c77fdca.jpg";